import React, { useEffect, useState } from "react";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import FileImport from "components/FileImport";
import { importDictionaryFromArchive } from "slices/dictionary/actions/dictionary";
import Switch from "components/Switch";
import PropTypes from "prop-types";

export const dictionaryExtension = {
  xml: "xml",
  csv: "csv",
};
const ImportDictionaryModal = ({ navigate }) => {
  const dispatch = useDispatch();
  const [okButtonDisabled, setOkButtonDisabled] = useState(true);
  const [selectedFile, setSelectedFile] = useState("");
  const [fileExtension, setFileExtension] = useState(dictionaryExtension.xml);
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (!okButtonDisabled) {
      const formData = new FormData();
      formData.append("importedFile", selectedFile, selectedFile.name);
      if (fileExtension === dictionaryExtension.csv) {
        formData.append("dictionaryName", selectedFile.name.slice(0, -4));
      }
      dispatch(importDictionaryFromArchive(formData, navigate, fileExtension));
    }
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onEnterKeyDown = ({ key }) => {
    if (key === "Enter" && !okButtonDisabled) {
      handleSubmit();
    }
  };

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.IMPORT_DICTIONARY));
  };

  const handleSwitch = () => {
    setSelectedFile("");
    if (fileExtension === dictionaryExtension.csv) {
      setFileExtension(dictionaryExtension.xml);
    } else {
      setFileExtension(dictionaryExtension.csv);
    }
  };

  useEffect(() => {
    if (selectedFile && selectedFile.name.endsWith(fileExtension)) {
      setOkButtonDisabled(false);
      setError("");
    } else {
      setOkButtonDisabled(true);
      if (selectedFile) {
        setError(
          `You can only upload ${fileExtension.replace(
            ".",
            ""
          )} files. Please chose a file with the extension '${fileExtension}'`
        );
      }
    }
  }, [selectedFile]);

  useEffect(() => {
    setError("");
  }, [fileExtension]);

  const fileTypeSwitch = () => (
    <div className="import_dictionary__body__file_type">
      <span>File Type</span>
      <div>
        <span
          className={`${
            fileExtension === dictionaryExtension.csv ? "active" : "inactive"
          }`}
        >
          Import CSV
        </span>
        <Switch
          handleChange={handleSwitch}
          currentSwitchState={fileExtension !== dictionaryExtension.csv}
          id="export-content-xlsx-switch"
        />
        <span
          className={`${
            fileExtension === dictionaryExtension.xml ? "active" : "inactive"
          }`}
        >
          Import Archive (xml)
        </span>
      </div>
    </div>
  );

  const modalBody = () => (
    <div className="import_dictionary__body">
      {fileTypeSwitch()}
      <div className="import_file">
        <FileImport
          accepts={`.${fileExtension}`}
          handleFileChange={handleFileChange}
          selectedFile={selectedFile}
          error={error}
        />
      </div>
    </div>
  );

  return (
    <Modal
      data-test="importDictionaryModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
      onKeyDown={onEnterKeyDown}
    >
      <Modal.Header closeButton>
        <b className="import_dictionary__header">Import Dictionary</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          dataTestId="importButton"
          variant={buttonVariants.primary}
          onClick={handleSubmit}
          disabled={selectedFile === "" || error !== ""}
          content="Import"
        />
        <Button
          dataTestId="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ImportDictionaryModal;

ImportDictionaryModal.propTypes = {
  navigate: PropTypes.func,
};
